<template>
  <section class="character-traits">
    <header class="section-header">
      <h2 class="form-title h3">What Do You Admire About Them?</h2>
      <p>For each of the role models you have entered, list out the positive character traits that come to mind when you think of them. You may either <strong>select from the list of suggestions or manually enter any trait.</strong>  You are not limited to the suggestions!</p>
    </header>

    <div class="section-body">
      <div class="column">
        <div class="column-header">
          <h3 class="h4 column-title">Suggestions</h3>
          <p><strong>Select any character trait below to add it to the current role model</strong>.
          </p>
        </div>

        <div class="trait-suggestions">
          <div v-for="category in traitSuggestions">
            <h4 class="category h6 caption">{{ category.category }}</h4>
            <div class="traits">
              <button v-for="trait in category.traits" class="primary hollow button" @click="addTraitToCurrentRoleModel(trait)">{{ trait }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="column-header">
          <h3 class="h4 column-title">
            {{ $parent.roleModels[currentRoleModelIndex].name }} ({{ currentRoleModelIndex + 1 }} of {{ $parent.roleModels.length }})
          </h3>
          <div class="progress-bar">
            <div class="progress">
            <span v-for="(roleModel, index) in $parent.roleModels" @click="currentRoleModelIndex = index"
                  :class="{complete: index < currentRoleModelIndex, current: index === currentRoleModelIndex}">
              {{ index + 1 }}
            </span>
            </div>
          </div>
        </div>
        <!-- Progress Bar -->


        <!-- Character Traits Input -->
        <div v-for="(roleModel, roleModelIndex) in $parent.roleModels">
          <div v-if="currentRoleModelIndex === roleModelIndex" class="role-model-traits">
            <div v-for="(trait, traitIndex) in roleModel.traits">
              <div class="input-wrapper">
                <input @keyup="updateTrait($event, traitIndex)" @keyup.enter="addTraitEnter($event, traitIndex)"
                       :value="trait" ref="characterTrait" placeholder="Enter a trait or select a suggestion">
                <span class="delete" @click="removeTrait(traitIndex)">X</span>
              </div>
            </div>
            <div class="add-trait-wrapper">
              <span class="add-trait" tabindex="0" @click="addTrait()" @keyup.enter="addTrait()">[+]</span>
            </div>
          </div>
        </div>

        <nav class="next-prev-role-model">
          <button v-if="currentRoleModelIndex > 0" class="button hollow secondary" @click="previousRoleModel">Previous Role Model
          </button>
          <button v-if="(currentRoleModelIndex + 1) < $parent.roleModels.length" class="button filled secondary next"
                  @click="nextRoleModel">Next Role Model
          </button>
        </nav>

        <p class="next-step-message">After entering positive character traits for all of your role models, <strong>continue on below to the Next Step</strong>.</p>
      </div>

      <!-- Next Step -->
      <footer class="section-footer">
<!--        <p>After entering all of your role models, continue on to the Next Step</p>-->
        <div class="next-prev-step">
          <button class="button accent-1 hollow" @click="$parent.previousStep()">Prev Step</button>
          <button class="button accent-1 filled" @click="$parent.nextStep()" :disabled="characterTraitsEmpty">Next Step</button>
        </div>
      </footer>
    </div>

  </section>
</template>

<script>

export default {
  props: {},
  data() {
    return {
      currentRoleModelIndex: 0,
      traitSuggestions:                [
        {
          category: "Personal Growth & Mindset",
          traits:    [
            "Adaptable",
            "Ambitious",
            "Authentic",
            "Brave",
            "Calm",
            "Capable",
            "Confident",
            "Courageous",
            "Curious",
            "Disciplined",
            "Energetic",
            "Enthusiastic",
            "Focused",
            "Grateful",
            "Growth-Oriented",
            "Honest",
            "Optimistic",
            "Patient",
            "Resilient",
            "Self-Motivated",
          ]
        },
        {
          category: "Social & Relationship",
          traits:    [
            "Accepting",
            "Assertive",
            "Charismatic",
            "Collaborative",
            "Compassionate",
            "Considerate",
            "Dependable",
            "Diplomatic",
            "Empathetic",
            "Encouraging",
            "Friendly",
            "Generous",
            "Helpful",
            "Humorous",
            "Inspiring",
            "Kind",
            "Loyal",
            "Respectful",
            "Supportive",
            "Trustworthy",
          ]
        },
        {
          category: "Professional & Leadership",
          traits:    [
            "Accountable",
            "Analytical",
            "Attentive",
            "Calculated",
            "Competent",
            "Decisive",
            "Detail-Oriented",
            "Driven",
            "Ethical",
            "Goal-Oriented",
            "Influential",
            "Innovative",
            "Inspirational",
            "Integrity-Driven",
            "Leader",
            "Organized",
            "Persuasive",
            "Problem-Solver",
            "Resourceful",
            "Visionary",
          ]
        }
      ]
    }
  },
  mounted() {
    this.$refs["characterTrait"][0].focus();
  },
  computed: {
    characterTraitsEmpty() {
      let roleModels = this.$parent.roleModels;
      let traits = [];
      for (let i = 0; i < roleModels.length; i++) {
        for (let j = 0; j < roleModels[i].traits.length; j++) {
          // console.log(roleModels[i].traits[j]);
          if (roleModels[i].traits[j]) {
            traits.push(roleModels[i].traits[j]);
          }

        }
      }
      return traits.length === 0;
    }
  },
  methods: {
    addTrait() {
      this.$parent.roleModels[this.currentRoleModelIndex].traits.push("");
      setTimeout(() => {
        this.$refs["characterTrait"][this.$parent.roleModels[this.currentRoleModelIndex].traits.length - 1].focus();
      }, 20)
    },
    addTraitEnter(event, index) {
      if (event.target.value) {
        this.$parent.roleModels[this.currentRoleModelIndex].traits.push("")
        setTimeout(() => {
          this.$refs["characterTrait"][index + 1].focus();
        }, 20)

      }
    },
    addTraitToCurrentRoleModel(trait) {
      let currentRoleModelTraits = this.$parent.roleModels[this.currentRoleModelIndex].traits;
      if(currentRoleModelTraits[currentRoleModelTraits.length - 1] === "") {
        currentRoleModelTraits[currentRoleModelTraits.length - 1] = trait;
      } else {
        this.$parent.roleModels[this.currentRoleModelIndex].traits.push(trait);
      }

    },
    removeTrait(index) {
      this.$parent.roleModels[this.currentRoleModelIndex].traits.splice(index, 1);
    },
    updateTrait(event, index) {
      this.$parent.roleModels[this.currentRoleModelIndex].traits[index] = event.target.value;
    },
    nextRoleModel() {
      this.currentRoleModelIndex++;
      setTimeout(() => {
        this.$refs["characterTrait"][this.$parent.roleModels[this.currentRoleModelIndex].traits.length - 1].focus();
      }, 20)
    },
    previousRoleModel() {
      this.currentRoleModelIndex--;
      setTimeout(() => {
        this.$refs["characterTrait"][this.$parent.roleModels[this.currentRoleModelIndex].traits.length - 1].focus();
      }, 20)
    }
  }
}
</script>
